/* eslint-disable camelcase */
import { Howl } from 'howler';
import Vue from 'vue';
import { activity, student, mapMutations, mapState } from '../store/helpers';
const { VUE_APP_AUDIO_PREFIX } = process.env;
export default Vue.extend({
    created() {
        if (this.isActiveAssessment) {
            const filePath = `${VUE_APP_AUDIO_PREFIX}/help/askyourteacherforhelp.mp3`;
            this.help = new Howl({
                src: [filePath],
                volume: this.accessibilitySettings.audioSettings.muteSounds
                    ? 0
                    : this.accessibilitySettings.audioSettings.volume * 0.01,
                onloaderror: () => ({
                    play: () => { },
                    stop: () => { }
                })
            });
        }
    },
    computed: Object.assign(Object.assign({}, mapState(student, ['accessibilitySettings'])), mapState(activity, {
        // @ts-ignore
        isSpotCheck: state => Boolean(state.data.spotCheck),
        // @ts-ignore
        isActiveAssessment: state => Boolean(state.data.scheduledActivityId)
    })),
    data() {
        return {
            timer: undefined,
            maxTimer: undefined,
            inactivityTime: 1000 * 30,
            totalTime: 1000 * 60 * 5,
            timerActive: false,
            help: {
                play: () => { },
                stop: () => { }
            }
        };
    },
    beforeDestroy() {
        this.endTimer();
        this.setAssessmentHelpBtn(false);
    },
    methods: Object.assign(Object.assign({}, mapMutations(activity, ['setAssessmentHelpBtn'])), { timerAlert() {
            this.endTimer();
            this.setAssessmentHelpBtn(true);
        },
        resetTimer() {
            if (this.timerActive) {
                window.clearTimeout(this.timer);
                this.timer = window.setTimeout(this.timerAlert, this.inactivityTime);
            }
        },
        registerEvents() {
            window.addEventListener('mousemove', this.resetTimer);
            window.addEventListener('mousedown', this.resetTimer);
            window.addEventListener('touchstart', this.resetTimer);
            window.addEventListener('click', this.resetTimer);
        },
        unregisterEvents() {
            window.removeEventListener('mousemove', this.resetTimer);
            window.removeEventListener('mousedown', this.resetTimer);
            window.removeEventListener('touchstart', this.resetTimer);
            window.removeEventListener('click', this.resetTimer);
        },
        startTimer() {
            this.registerEvents();
            this.timerActive = true;
            this.maxTimer = window.setTimeout(this.timerAlert, this.totalTime);
            this.timer = window.setTimeout(this.timerAlert, this.inactivityTime);
        },
        endTimer() {
            this.unregisterEvents();
            this.timerActive = false;
            clearTimeout(this.timer);
            clearTimeout(this.maxTimer);
        },
        playHelpSnd() {
            return this.help.play();
        } })
});
